import { Chain } from "viem";
import { IGlobalStore } from "../store/global/GlobalStore";
import { isNativeToken, isWrapToken } from "./wrapUtils";

export const enum OrderType {
  OneToOne = "121",
  OneToMany = "12M",
  ManyToOne = "M21",
}
export const getOrderType = (
  takerTokens: IGlobalStore["takerTokens"],
  makerTokens: IGlobalStore["makerTokens"]
): OrderType | undefined => {
  const numMakerTokens = makerTokens.length;
  const numTakerTokens = takerTokens.length;
  if (numTakerTokens === 1 && numMakerTokens === 1) {
    return OrderType.OneToOne;
  } else if (numTakerTokens > 1 && numMakerTokens === 1) {
    return OrderType.ManyToOne;
  } else if (numMakerTokens > 1 && numTakerTokens === 1) {
    return OrderType.OneToMany;
  }
  return undefined;
};

export const getOrderTypeName = (orderType: OrderType) => {
  if (orderType === OrderType.OneToOne) {
    return "One to one";
  } else if (orderType === OrderType.ManyToOne) {
    return "Many to one";
  } else {
    // else catches not just 12M orderType but also 12MPercentages which comes back from the backend on some older trades
    return "One to many";
  }
};

export const isWrapTrade = (
  takerTokens: IGlobalStore["takerTokens"],
  makerTokens: IGlobalStore["makerTokens"],
  chain: Chain
) => {
  if (
    getOrderType(takerTokens, makerTokens) === OrderType.OneToOne &&
    ((isNativeToken(takerTokens[0].tokenAddress, chain) &&
      isWrapToken(makerTokens[0].tokenAddress, chain)) ||
      (isNativeToken(makerTokens[0].tokenAddress, chain) &&
        isWrapToken(takerTokens[0].tokenAddress, chain)))
  ) {
    console.log(`Wrap trade detected`);
    return true;
  }
  return false;
};
